// Appends the next page of a [data-next-url] grid as the visitor nears the bottom.
// The pagination links stay in the markup as the no-JS fallback.
document.querySelectorAll('[data-next-url]').forEach((grid) => {
  const pager = grid.parentElement.querySelector('.pagination-wrapper');
  if (!grid.dataset.nextUrl) return;
  if (pager) pager.hidden = true;

  const sentinel = document.createElement('div');
  // base.css hides div:empty, which would stop the observer from ever firing.
  sentinel.style.cssText = 'display:block;height:1px';
  grid.after(sentinel);

  let loading = false;
  const observer = new IntersectionObserver(
    async ([entry]) => {
      if (!entry.isIntersecting || loading) return;
      loading = true;
      try {
        const url = new URL(grid.dataset.nextUrl, location.origin);
        url.searchParams.set('section_id', grid.dataset.sectionId);
        const html = await fetch(url).then((r) => {
          if (!r.ok) throw new Error(r.status);
          return r.text();
        });
        const next = new DOMParser().parseFromString(html, 'text/html').getElementById(grid.id);
        grid.append(...next.children);
        grid.dataset.nextUrl = next.dataset.nextUrl;
        // Wire up Swym wishlist buttons on the newly added cards.
        window._swat?.initializeActionButtons?.(`#${grid.id}`);
      } catch (e) {
        grid.dataset.nextUrl = '';
        if (pager) pager.hidden = false;
      }
      loading = false;
      observer.unobserve(sentinel);
      // Re-observing fires again right away if the sentinel is still on screen.
      if (grid.dataset.nextUrl) observer.observe(sentinel);
      else sentinel.remove();
    },
    { rootMargin: '800px 0px' }
  );
  observer.observe(sentinel);
});
